var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback } from "react";
import { useParams } from "react-router-dom";
import { usePlaylistDetail, usePlaylistEdit } from "frontend/src/domain/playlists";
import { useTrackCountMap } from "frontend/src/domain/tracks";
import { useViewerAdvertisements } from "frontend/src/domain/audio-advertisements";
import { usePlayerTrackId } from "frontend/src/domain/player-track-queue";
import { playUserFilesAttempted } from "frontend/src/features/play-user-files";
import { pause, resume } from "frontend/src/features/control-audio";
import { playPlaylistAttempted } from "frontend/src/features/play-playlist";
import { useIsAudioPlaying } from "frontend/src/domain/audio";
export var usePagePlaylist = function () {
    var id = useParams().id;
    var playlist = usePlaylistDetail(Number(id)).playlist;
    return { playlist: playlist };
};
export var usePlaylist = function (initial) {
    var playlist = usePlaylistEdit(initial);
    var addedTrackCounterMap = useTrackCountMap(playlist.entries.tracks);
    var onTitleChange = function (evt) {
        return playlist.title.set(evt.target.value);
    };
    var update = function (evt) {
        evt.preventDefault();
        playlist.update.run();
    };
    var play = useCallback(function (_a) {
        var selected = _a.selected, index = _a.index;
        if (selected) {
            resume();
        }
        else {
            playPlaylistAttempted({
                id: initial.id,
                title: initial.title,
                startAtTrackIndex: index,
                tracks: playlist.entries.tracks,
            });
        }
    }, [playlist.entries.tracks, initial.id, initial.title]);
    return {
        title: { value: playlist.title.value, onChange: onTitleChange },
        entries: __assign(__assign({}, playlist.entries), { tracks: { all: playlist.entries.tracks, countMap: addedTrackCounterMap } }),
        actions: {
            play: play,
            pause: pause,
            update: {
                do: update,
                pending: playlist.update.pending,
            },
        },
    };
};
export var useViewerAddableAudioAdvertisementList = function (_a) {
    var _b, _c;
    var tracks = _a.tracks;
    var playerTrackId = usePlayerTrackId();
    var isAudioPlaying = useIsAudioPlaying();
    var advertisements = useViewerAdvertisements();
    var items = (_b = advertisements.data) === null || _b === void 0 ? void 0 : _b.map(function (_a, index, array) {
        var _b;
        var id = _a.id, title = _a.title, duration = _a.duration, url = _a.url;
        var selected = id === playerTrackId;
        var playing = selected && isAudioPlaying;
        var paused = selected && !isAudioPlaying;
        var play = function () {
            return selected
                ? resume()
                : playUserFilesAttempted({
                    tracks: array,
                    startAtTrackIndex: index,
                });
        };
        var add = function () {
            return tracks.add({
                type: "private",
                id: id,
                title: title,
                duration: {
                    seconds: duration.seconds,
                    formatted: duration.formatted,
                },
                url: url,
            });
        };
        var remove = function () { return tracks.remove(id); };
        return {
            id: id,
            title: title,
            duration: duration.formatted,
            selected: selected,
            loading: false,
            playing: playing,
            paused: paused,
            addCount: (_b = tracks.countMap[id]) !== null && _b !== void 0 ? _b : 0,
            actions: {
                add: add,
                remove: remove,
                play: play,
                pause: pause,
            },
        };
    });
    var empty = (_c = (items === null || items === void 0 ? void 0 : items.length) === 0) !== null && _c !== void 0 ? _c : false;
    return { empty: empty, items: items };
};
